import React, { useEffect } from "react"
import { Link, navigate } from "@reach/router"
import { getCurrentUser, isLoggedIn, logout } from "../../utils/auth"
import * as styles from "./status.module.css"
import queryString from "query-string"
import { useNavigationDispatch, useNavigationState } from "../navigation-context"
import styled from "styled-components"

const Bolded = styled.span`
    font-weight: bold;
`


export default (props) => {

  const state = useNavigationState()
  const dispatch = useNavigationDispatch()

  useEffect(() => {
    if (props.location && props.location.state && props.location.state.donationpage) {
      dispatch({ type: 'donationpage', target: props.location.state.donationpage })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  const returnToPageText = () => {return `Återgå`}
  const returnToArticleText = () => {return `Återgå till artikeln`}

  function getDonationPageLink() {
    let donationpage = state.donationpage;

    if (donationpage && donationpage.length > 0 ) {
      return (<span>
                  {` `}
                -
                {` `}
                <Link to={`${donationpage}`}>{returnToPageText()}</Link>
              </span>);
    } else {
      return "";
    }
  }

  const pageIsInIFrame = () => {
    return (window !== window.parent);
  }

  const getReturnToArticleLink = () => {

    let returnLink;

    let queryParams;
    if (props.location) {
      queryParams = queryString.parse(props.location.search)

      if ('ol' in queryParams && queryParams['ol']==='d') {
        let page_url = "";
        if ('origin' in queryParams) {
          page_url = queryParams['origin'];
        } else if ('s' in queryParams) {
          page_url = queryParams['s'];
        }

        returnLink = (
          <>
            {(window !== window.parent) ?
              <a
                href="/"
                onClick={event => {
                  event.preventDefault()
                  window.parent.postMessage("Close", page_url);
                  window.postMessage("Close", page_url);
                }}
              > {returnToArticleText()}
              </a>
              :
              <a href={page_url}>
                {returnToArticleText()}
              </a>
            }
          </>
        );
      } else if ('ol' in queryParams && queryParams['ol']==='s') {
        // TODO For now, display no return link for subscriptions due
        // to cross browser issues, ticket 221
        returnLink = "";
      } else if ('origin' in queryParams) {
        returnLink = (
          <a
            href={queryParams['origin']}
          >
            {returnToArticleText()}
          </a>
        );
      } else if ('s' in queryParams) {
        returnLink = (
          <a
            href={queryParams['s']}
          >
            {returnToArticleText()}
          </a>
        );
      }
    }

    if (props.menuoptions.close && queryParams && returnLink) {
      return(
        <span>
          {` `}
          -
          {` `}

          {returnLink}

        </span>
      );
    } else {
      return "";
    }
  }

  let details;
  if (!isLoggedIn()) {
    details = (
      <p className={styles[`status__text`]}>
        {getReturnToArticleLink()}
      </p>
    )
  } else {
    const userdata = getCurrentUser()

    details = (
      <p className={styles[`status__text`]}>
        <Bolded>MinSida:</Bolded> Du är inloggad som <Link to="/app/profile/" state={{ donationpage: state.donationpage }}>{userdata.username}</Link>

        {getReturnToArticleLink()}

        {props.menuoptions.returnToDonation ? (
          getDonationPageLink()
          ) : null }
        {props.menuoptions.logout ? (
        <span>
        {` `}
        -
        {` `}
        <a
          href="/"
          onClick={event => {
            event.preventDefault()
            logout(() => navigate(`/app/login`))
          }}
        >
          Logga ut från denna enhet
        </a>
        </span>) : null }

      </p>
    )
  }

  return <div className={styles.status}><div className={styles.status_loginmenu}>{details}</div></div>
}
